import axios from 'axios'

const state = {}

// getters
const getters = {}

// actions
const actions = {
  async getList(app, pagination) {
    const { page } = pagination
    let order

    if (pagination.descending) {
      order = 'desc'
    } else {
      order = 'asc'
    }

    const { data } = await axios.get('/api/v1/users', {
      params: { page, order },
    })

    return data
  },

  async getById(app, { id }) {
    const { data } = await axios.get(`/api/v1/users/${id}`)
    return data
  },

  async getByRole(app, { role }) {
    const { data } = await axios.get(`/api/v1/users?role=${role}&status=ACTIVE&unpaginated=true`)
    return data
  },

  async create(app, payload) {
    const { data } = await axios.post('/api/v1/users', payload)
    return data
  },

  async update(app, payload) {
    const { data } = await axios.put(`/api/v1/users/${payload.id}`, payload)
    return data
  },

  async delete(app, payload) {
    const { data } = await axios.delete(`/api/v1/users/${payload.id}`)
    return data
  },

  async buyCredits(app, { userId, amount, pmId }) {
    const { data } = await axios.post(`/api/v1/users/${userId}/buy_credits`, {
      amount,
      pm_id: pmId,
    })

    return data
  },

  async checkCurrentPassword(app, { currentPassword }) {
    const { data } = await axios.get(`/api/v1/validation/check_password/${currentPassword}`)
    return data
  },

  async changePassword(app, { oldPassword, newPassword }) {
    const { data } = await axios.post(`/api/v1/users/change_password`, { oldPassword, newPassword })
    return data
  }
}

// mutations
const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
